import React, { Component } from 'react';
import {
  Card,
  Table,
  Popup,
  Radio,
  Statistic,
  StatisticGroup,
  StatisticLabel,
  StatisticValue,
  Icon,
  Button,
  Label,
} from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import hasRESTClient from '../../hocs/has-rest-client';
import countries from '../../utils/helpers/countries';


const formatNumber = (num, numFormat) => {
  if (numFormat) {
    return numeral(num).format(numFormat);
  }
  let format = num > 1000 ? '0a' : '0';
  format = (num > 1000000) ? '0.0a' : format;
  return numeral(num).format(format);
};

const getPercentage = (total, value) => {
  if (total > 0 && value > 0) {
    return _.round(_.divide(value, total) * 100);
  }
  return 0;
};

const percentageStyle = {
  fontSize: '10px',
  opacity: '0.5',
};
const processBlockStyles = {
  backgroundColor: '#FFEFD5',
};
const contentBlockStyles = {
  backgroundColor: '#D2F3EC',
};
const performanceBlockStyles = {
  backgroundColor: '#FFF4F8',
};

const totalsRowStyles = {
  fontWeight: 900,
  backgroundColor: '#D2D1D7',
};
const MAX_WEEKS = 12;
const getCampaignPhase = fullWeeks => {
  if (fullWeeks) {
    if (fullWeeks > MAX_WEEKS) return 'COMPLETE';
    if (fullWeeks > 6) return 'TRACKING';
    return 'RECRUITMENT & ORDERING';
  }
};
class CampaignReportCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      report: null,
      isLoading: false,
      error: null,
    };
  }

  render() {
    const {
      title,
      isLoading,
      campaigns,
      showReviewedInfluencers,
      showContactedInfluencers,
      onGroupViewToggle,
      showCampaignTitle,
      isReloading,
      month,
      onReload,
      showContactedInfluencersValue,
      showReviewedInfluencersValue,
    } = this.props;


    const totalInfluencers = _.sumBy(campaigns, 'totalInfluencers');
    const totalInfluencersReviewed = _.sumBy(campaigns, 'influencersReviewed');
    const totalInfluencersSignedUp = _.sumBy(campaigns, 'influencers');
    const totalInfluencersSignedUpPercentage = getPercentage(totalInfluencers, totalInfluencersSignedUp);
    const totalInfluencersPercentage = getPercentage(totalInfluencersReviewed, totalInfluencers);
    const totalInfluencersOrdered = _.sumBy(campaigns, 'influencersOrdered');
    const totalInfluencersOrderedPercentage = getPercentage(totalInfluencersSignedUp, totalInfluencersOrdered);
    const totalInfluencersPosted = _.sumBy(campaigns, 'influencersPosted');
    const totalInfluencersPostedPercentage = getPercentage(totalInfluencersOrdered, totalInfluencersPosted);
    const totalStories = _.sumBy(campaigns, 'stories');
    const totalGridpost = _.sumBy(campaigns, 'gridpost');
    const totalReels = _.sumBy(campaigns, 'reels');
    const totalTiktoks = _.sumBy(campaigns, 'tiktoks');
    const totalReach = _.sumBy(campaigns, 'reach');
    const totalImpressions = _.sumBy(campaigns, 'impressions');
    const totalViews = _.sumBy(campaigns, 'views');
    const totalEngagements = _.sumBy(campaigns, 'engagements');
    const totalAssets = totalStories + totalGridpost + totalReels + totalTiktoks;

    const campaign = _.head(campaigns);
    const brand = _.get(campaign, 'brand');

    const liveDate = campaign && campaign.liveDate;

    let fullWeeks;
    if (liveDate) {
      fullWeeks = moment().startOf('week').diff(moment(liveDate).startOf('week'), 'weeks');
    }

    const totalCost = ((totalInfluencersOrdered * 20) + 3000);
    const totalEmv = ((totalImpressions * 10) + (totalEngagements * 100)) / 1000;
    const finalRoi = ((totalEmv - totalCost) / totalCost);

    const canRenderCalcs = totalCost && totalInfluencersOrdered;

    const campaignPhase = getCampaignPhase(fullWeeks);
    return (
      <div style={{ marginTop: '40px', clear: 'all' }}>
        <Card color="green" fluid>

          <Card.Content>

            <table width="100%">
              <tr>
                <td width="50%">
                  <h2>{title}</h2>
                  <Label basic color="blue" size="large">{brand || 'NOT SET'}</Label>
                </td>

                <td width="20%">
                  <Label basic color="blue">
                WEEK {fullWeeks} of {MAX_WEEKS}
                  </Label>
                </td>
                <td width="20%">
                  {campaignPhase &&
                  <Label basic color="grey">
                    {campaignPhase}
                  </Label>
                  }
                </td>

                <td width="10%">
                  <Popup
                    trigger={
                      <Button
                        circular inverted color="green" icon="refresh"
                        onClick={() => (isReloading ? null : onReload(month, true))}
                        loading={isReloading}
                        floated="right"
                      />
                    }
                    content="Click here reload report"
                  />
                </td>
              </tr>
            </table>


          </Card.Content>


          <Card.Content>
            <StatisticGroup size="tiny" widths="8">
              <Statistic color="pink">
                <StatisticValue>
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{totalAssets}</span>
                  }
                </StatisticValue>
                <StatisticLabel>total assets</StatisticLabel>
              </Statistic>

              <Statistic color="pink">
                <StatisticValue>
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{totalInfluencersOrdered}</span>
                  }
                </StatisticValue>
                <StatisticLabel>total gifts</StatisticLabel>
              </Statistic>

              <Statistic>
                <StatisticValue>
                  <Icon name="dollar" size="small" color="green" />
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{numeral(totalInfluencersOrdered * 20).format('0,0')}</span>
                  }
                </StatisticValue>
                <Popup
                  content="Cost of gift (est $20) times the number of gifts ordered"
                  trigger={<StatisticLabel>total cost</StatisticLabel>}
                />
              </Statistic>

              <Statistic>
                <StatisticValue>
                  <Icon name="dollar" size="small" color="green" />
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{
                      canRenderCalcs
                        ? numeral(((totalInfluencersOrdered * 20) + 3000) / totalAssets).format('0.00')
                        : '-'}
                    </span>
                  }
                </StatisticValue>
                <Popup
                  content="Product cost (gifts) plus Shopfluence fee, divided by total assets"
                  trigger={<StatisticLabel>total CPA</StatisticLabel>}
                />
              </Statistic>

              <Statistic>
                <StatisticValue>
                  <Icon name="dollar" size="small" color="green" />
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{canRenderCalcs ? numeral(3000 / totalAssets).format('0.00') : '-'}</span>
                  }
                </StatisticValue>
                <Popup
                  content="Shopfluence monthly fee, divided by total assets"
                  trigger={<StatisticLabel>CPA (SaaS)</StatisticLabel>}
                />
              </Statistic>

              <Statistic>
                <StatisticValue>
                  <Icon name="dollar" size="small" color="green" />
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>
                      { canRenderCalcs
                        ? numeral(((totalInfluencersOrdered * 20) * 1000) / totalImpressions).format('0.00')
                        : '-'}
                    </span>
                  }
                </StatisticValue>
                <StatisticLabel>CPM</StatisticLabel>
              </Statistic>

              <Statistic>
                <StatisticValue>
                  <Icon name="dollar" size="small" color="green" />
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{canRenderCalcs ? numeral(totalEmv).format('0,0') : '-'}</span>
                  }
                </StatisticValue>
                <Popup
                  content="Total Impressions * $10 CPM + Total Engagements * $100 CPM"
                  trigger={<StatisticLabel>EMV</StatisticLabel>}
                />
              </Statistic>

              <Statistic color="blue">
                <StatisticValue>
                  {isLoading
                    ? <Icon name="hourglass outline" color="orange" />
                    : <span>{canRenderCalcs ? numeral(finalRoi).format('%') : '-'}</span>
                  }
                </StatisticValue>
                <Popup
                  content="Value of media earned against cost of goods + SaaS"
                  trigger={<StatisticLabel>ROI</StatisticLabel>}
                />
              </Statistic>
            </StatisticGroup>

          </Card.Content>
          <Card.Content>
            {!isLoading &&
            <div style={{ display: 'flex', justifyContent: 'flex-between', alignItems: 'center' }}>
              {onGroupViewToggle &&
              <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '8px' }}>Group reports</span>
                <Radio
                  toggle
                  defaultChecked
                  onChange={onGroupViewToggle}
                />
              </div>
              }


            </div>
            }
            { !isLoading &&
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={2} />
                  {showReviewedInfluencers && <Table.HeaderCell textAlign="center" style={processBlockStyles} width={1}>
                    Influencers Reviewed
                  </Table.HeaderCell>}
                  { showContactedInfluencers && <Table.HeaderCell textAlign="center" style={processBlockStyles} width={1}>
                    Influencers Contacted
                  </Table.HeaderCell>}
                  <Table.HeaderCell textAlign="center" style={processBlockStyles} width={1}>
                    Influencers Signed-up
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={processBlockStyles} width={1}>
                    Influencers Ordered
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={processBlockStyles} width={1}>
                    Influencers Posted
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={contentBlockStyles} width={1}>
                    Instagram Stories
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={contentBlockStyles} width={1}>
                    Instagram Gridposts
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={contentBlockStyles} width={1}>
                    Instagram Reels
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={contentBlockStyles} width={1}>
                    TikToks
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={performanceBlockStyles} width={1}>
                    Reach
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={performanceBlockStyles} width={1}>
                    <Popup content="Impressions" trigger={<span>Imps.</span>} />
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={performanceBlockStyles} width={1}>
                    Views
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={performanceBlockStyles} width={1}>
                    <Popup content="Engagements" trigger={<span>Engs.</span>} />
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center" style={performanceBlockStyles} width={1}>
                    <Popup content="Earned Media Value" trigger={<span>EMV</span>} />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  _.map(campaigns, campaign => <ReportTableRow
                    key={campaign.id}
                    campaignReport={campaign}
                    showReviewedInfluencers={showReviewedInfluencers}
                    showContactedInfluencers={showContactedInfluencers}
                    showCampaignTitle={showCampaignTitle}
                    showContactedInfluencersValue={showContactedInfluencersValue}
                    showReviewedInfluencersValue={showReviewedInfluencersValue}
                  />)
                }
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row style={totalsRowStyles}>
                  <Table.HeaderCell style={totalsRowStyles}>
                    Totals
                  </Table.HeaderCell>
                  { showReviewedInfluencers &&
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    { showReviewedInfluencersValue && formatNumber(totalInfluencersReviewed, '0,0')}
                  </Table.HeaderCell>}
                  {showContactedInfluencers && <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {showContactedInfluencersValue && formatNumber(totalInfluencers, '0,0')} {' '}
                    {showContactedInfluencersValue && <span style={percentageStyle}>{totalInfluencersPercentage}%</span>}
                  </Table.HeaderCell>}
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalInfluencersSignedUp, '0,0')} {' '}
                    {showContactedInfluencers &&
                      <span style={percentageStyle}>{totalInfluencersSignedUpPercentage}%</span>
                    }
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalInfluencersOrdered, '0,0')} <span style={percentageStyle}>{totalInfluencersOrderedPercentage}%</span>
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalInfluencersPosted, '0,0')} <span style={percentageStyle}>{totalInfluencersPostedPercentage}% </span>
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalStories, '0,0')}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalGridpost, '0,0')}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalReels, '0,0')}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalTiktoks, '0,0')}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalReach)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalImpressions)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalViews)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    {formatNumber(totalEngagements)}
                  </Table.HeaderCell>
                  <Table.HeaderCell style={totalsRowStyles} textAlign="right">
                    ${numeral(((totalImpressions * 10) + (totalEngagements * 100)) / 1000).format('0,0')}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>}
            {
              isLoading && <p>Loading...</p>
            }
          </Card.Content>
        </Card>
      </div>
    );
  }
}


const ReportTableRow = ({
  campaignReport,
  showContactedInfluencers,
  showReviewedInfluencers,
  showCampaignTitle,
  showContactedInfluencersValue,
  showReviewedInfluencersValue,
}) => {
  const {
    country,
    name,
    influencers,
    influencersReviewed,
    totalInfluencers,
    influencersOrdered,
    influencersPosted,
    stories,
    gridpost,
    tiktoks,
    views,
    engagements,
    reach,
    impressions,
    reels,
    id: campaignId,
  } = campaignReport;
  const countryName = _.find(countries, { key: country }).text;
  const title = showCampaignTitle ? name : countryName;
  const orderedPercentage = getPercentage(influencers, influencersOrdered);
  const postedPercentage = getPercentage(influencersOrdered, influencersPosted);
  const signedUpPercentage = getPercentage(totalInfluencers, influencers);
  const totalInfluencersPercentage = getPercentage(influencersReviewed, totalInfluencers);
  return (
    <Table.Row>
      <Table.Cell>
        <a href={`/campaign/${campaignId}/collaborations?fast=true`} target="_blank">
          <h3>{title}</h3>
        </a>
      </Table.Cell>
      { showReviewedInfluencers && <Table.Cell style={processBlockStyles} textAlign="right">
        {showContactedInfluencersValue && formatNumber(influencersReviewed, '0,0')}
      </Table.Cell>}
      {showContactedInfluencers && <Table.Cell style={processBlockStyles} textAlign="right">
        {showReviewedInfluencersValue && formatNumber(totalInfluencers, '0,0')} {' '}
        {showReviewedInfluencersValue && <span style={percentageStyle}>{totalInfluencersPercentage}%</span>}
      </Table.Cell>}
      <Table.Cell style={processBlockStyles} textAlign="right">
        {formatNumber(influencers, '0,0')} {' '} {showContactedInfluencers && <span style={percentageStyle}>{signedUpPercentage}%</span>}
      </Table.Cell>
      <Table.Cell style={processBlockStyles} textAlign="right">
        {formatNumber(influencersOrdered, '0,0')} <span style={percentageStyle}>{orderedPercentage}%</span>
      </Table.Cell>
      <Table.Cell style={processBlockStyles} textAlign="right">
        {formatNumber(influencersPosted, '0,0')} <span style={percentageStyle}>{postedPercentage}%</span>
      </Table.Cell>
      <Table.Cell style={contentBlockStyles} textAlign="right">
        {formatNumber(stories, '0,0')}
      </Table.Cell>
      <Table.Cell style={contentBlockStyles} textAlign="right">
        {formatNumber(gridpost, '0,0')}
      </Table.Cell>
      <Table.Cell style={contentBlockStyles} textAlign="right">
        {formatNumber(reels, '0,0')}
      </Table.Cell>
      <Table.Cell style={contentBlockStyles} textAlign="right">
        {formatNumber(tiktoks, '0,0')}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(reach)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(impressions)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(views)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        {formatNumber(engagements)}
      </Table.Cell>
      <Table.Cell style={performanceBlockStyles} textAlign="right">
        <a href={`https://share.dyzio.co/report/${campaignId}/emv`} target="_blank">
        ${numeral(((impressions * 10) + (engagements * 100)) / 1000).format('0,0')}
        </a>
      </Table.Cell>
    </Table.Row>
  );
};


CampaignReportCard.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  campaigns: PropTypes.array,
  onReload: PropTypes.func,
  month: PropTypes.string,
  isReloading: PropTypes.bool,
  showReviewedInfluencers: PropTypes.bool,
  showContactedInfluencers: PropTypes.bool,
  onGroupViewToggle: PropTypes.func,
  showCampaignTitle: PropTypes.bool,
  showContactedInfluencersValue: PropTypes.bool,
  showReviewedInfluencersValue: PropTypes.bool,
};

CampaignReportCard.defaultProps = {
  isLoading: false,
  campaigns: [],
  onReload: _.noop,
  month: '',
  isReloading: false,
  showReviewedInfluencers: false,
  showContactedInfluencers: false,
  onGroupViewToggle: null,
  showCampaignTitle: true,
  showContactedInfluencersValue: true,
  showReviewedInfluencersValue: true,
};

ReportTableRow.propTypes = {
  campaignReport: PropTypes.object.isRequired,
  showContactedInfluencers: PropTypes.bool.isRequired,
  showReviewedInfluencers: PropTypes.bool.isRequired,
  showCampaignTitle: PropTypes.bool.isRequired,
  showContactedInfluencersValue: PropTypes.bool,
  showReviewedInfluencersValue: PropTypes.bool,
};

ReportTableRow.defaultProps = {
  showContactedInfluencersValue: true,
  showReviewedInfluencersValue: true,
};
export default compose(hasRESTClient)(CampaignReportCard);



/** WEBPACK FOOTER **
 ** ./src/components/campaign-report-card/index.js
 **/